import '../style/cardStyle.css';
import { useSelector } from 'react-redux';
import CardCom from '../components/Card';
import { Typography } from '@mui/material';
import Progress from '../components/prograssBar';
import { Helmet } from 'react-helmet-async';

export default function AthkarElnom() {
    const value = useSelector((state) => state.athkarElnom.value);
    const card = useSelector((state) => state.athkarElnom.data);
    return (

        <>
            <Helmet>
                <title>أذكار النوم</title>
                <meta name='description' content='اذكار النوم' />
                <link rel="canonical" href="/athkarElnom" />
            </Helmet>

            <div className='mainScreen'>
                <Progress value={value} />
                <Typography variant="h3" component="p" className='title' sx={{ color: "text.primary" }}>أذكار النوم</Typography>
                <CardCom card={card} type={'nom'} />
            </div>

        </>
    );
}
